import { createContext, useContext } from 'react'
import type { AccordionContextValue } from './Accordion.types'

export const AccordionContext = createContext<AccordionContextValue | null>(
  null,
)

export const useAccordionContext = (): AccordionContextValue | null =>
  useContext(AccordionContext)
